import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StoreService {
  storeId = signal<string | null>(null);

  setStoreId(id: string | null) {
    console.log('StoreService.setStoreId called with:', id);
    this.storeId.set(id);
    console.log('StoreService.storeId is now:', this.storeId());
  }

  getStoreId() {
    return this.storeId();
  }

  hasStore() {
    const result = this.storeId() !== null && this.storeId() !== '';
    console.log('hasStore() returning:', result, 'storeId is:', this.storeId());
    return result;
  }
}
